export default __webpack_public_path__ + "static/media/house1-edited.efd10d9f.jpeg";